import React, { useContext, useEffect, useState } from "react";
import { Table, Tag, Space, Spin } from "antd";
import _ from "lodash";
import { AppTable } from "../../../_components/AppTable";
import { LanguageContext } from "../../../context/LanguageContext";
import { AppTable1 } from "../../../_components/AppTable1";

export const BaseFormTable = (props) => {
  console.log("props", props);
  const [criminalData, setCriminalData] = useState([]);
  const [criminalHeaders, setCriminalHeaders] = useState([]);
  const { language, setLanguage, t } = useContext(LanguageContext);
  const [sortedInfo, setSortedInfo] = useState({});
  if (props) {
    props.criminalRecords.forEach((item) => {
      if (
        Array.isArray(item.photo) &&
        item.photo.length === 1 &&
        typeof item.photo[0] === "string" &&
        item.photo[0].includes(",")
      ) {
        const newPhotos = item.photo[0].split(",");
        console.log("newPhotos", newPhotos);

        item.photo = [newPhotos[0], ...newPhotos.slice(1)];

        console.log("Updated item.photo", item.photo);
      }
    });

    props.criminalRecords?.forEach((item) => {
      if (item?.date_from) {
        item.date_from = formatDate(item.date_from);
      }
      if (item?.date_to) {
        item.date_to = formatDate(item.date_to);
      }
    });
  }

  function formatDate(dateString) {
    return new Date(dateString).toISOString().split("T")[0];
  }

  const requiredKeys = [
    "date_from",
    "date_to",
    "Sr.No",    
    "age",
    "preventiveActionName",
    "address",
    // "mobileNumber",
    "districtName",
    // "gunhaCount",
  ];

  const requiredKeys1 = [
    t("sr.no"),    
    t("age"),
    t("address"),
    t("phone"),
    "preventiveActionName",
    "districtName",
    // t("total_crimes"),
  ];

  // const requiredKeysTitle = [
  //   "Sr.No",
  //   "नाव",
  //   "वय",
  //   "पत्ता",
  //   // "फोन नंबर",
  //   "आरोपीचे पोलिस ठाणे",
  //   "प्रतिबंधक कारवाई",
  //   "कालावधी पासून",
  //   "कालावधी पर्यंत",
  //   "एकूण गुन्हा",
  // ];

  const requiredKeysTitle = [
    t("sr.no"),    
    t("age"),
    t("address"),
    // "फोन नंबर",
    t("accused_police_station"),
    // "प्रतिबंधक कारवाई",
    // t("total_crimes"),
  ];

  const requiredKeysTitle1 = [
    t("sr.no"),    
    t("age"),
    t("address"),
    t("phone_no"),
    t("accused_police_station"),
    t("preventive_action"),
    // t("total_crimes"),
  ];

  const getCityName = (id) => {
    const { pc_cities } = props.criminalRecords;
    if (pc_cities && pc_cities.length) {
      return (
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0].City
      );
    }
  };

  useEffect(() => {
    if (props?.criminalRecords && props?.criminalRecords) {
      let columns1 =
        props.criminalRecords &&
        props.criminalRecords &&
        props.criminalRecords.map((itemObj, index) => {
          return {
            ...itemObj,
            key: index + 1,
          };
        });

      // columns1 && columns1.length && columns1.reverse();

      let tempObj = columns1.map((res, index) => {
        return {
          ...res,
          photo:
            res.photo && res.photo[0] && res.photo[0].length
              ? res.photo[0]
              : null,
          "Sr.No": props.getSerialNumber(index, props.current, props.pageSize),
        };
      });
      setCriminalData(tempObj);

      let tablelabes =
        columns1 && columns1.length ? Object.keys(columns1[0]) : [];

      if (tablelabes.length) {
        tablelabes.unshift("Sr.No");

        tablelabes = tablelabes.filter(
          (label) => label !== "date_from" && label !== "date_to"
        );

        // tablelabes.push("date_from", "date_to");
      }

      let tableColumns = [];
      tablelabes &&
        tablelabes.length &&
        tablelabes.forEach((item) => {
          const requiredKey =
            props?.report === true ? requiredKeys1 : requiredKeys;
          if (
            _.filter(requiredKey, function (o) {
              return o === item;
            }).length
          ) {
            tableColumns.push(item);
          }
        });

      let columnList = tableColumns.map((item, index) => {
        return {
          title:
            props?.report === true
              ? requiredKeysTitle1[index]
              : requiredKeysTitle[index],
          dataIndex: item,
          key: item,
          sorter: ["आरोपीचे पोलिस ठाणे", "प्रतिबंधक कारवाई"].includes(
            props?.report ? requiredKeysTitle1[index] : requiredKeysTitle[index]
          )
            ? (a, b) => {
                if (
                  props?.report
                    ? requiredKeysTitle1[index] === "आरोपीचे पोलिस ठाणे"
                    : requiredKeysTitle[index] === "आरोपीचे पोलिस ठाणे"
                ) {
                  return a.districtName?.localeCompare(b.districtName);
                } else if (
                  props?.report
                    ? requiredKeysTitle1[index] === "प्रतिबंधक कारवाई"
                    : requiredKeysTitle[index] === "प्रतिबंधक कारवाई"
                ) {
                  return a.preventiveActionName?.localeCompare(
                    b.preventiveActionName
                  );
                }
                return 0;
              }
            : null,
        };
      });

      setCriminalHeaders(columnList);
    }
  }, [props.criminalRecords]);

  const handleTableChange = (sorter) => {
    setSortedInfo(sorter);
  };

  const onEditAccusedForm = (data) => {
    props.onEditAccusedForm(data);
  };

  const onPreventiveViewAccusedForm = (data) => {
    props.onPreventiveViewAccusedForm(data);
  };

  const onViewAccusedForm = (data) => {
    props.onViewAccusedForm(data);
  };

  return (
    <>
      {props?.PSFilledInfo == true ? (
        <AppTable
          districtId={props?.usersData?.districtId}
          cityid={props.cityid}
          isAccusedFormUpdate={true}
          onEditAccusedForm={onEditAccusedForm}
          onPreventiveViewAccusedForm={onPreventiveViewAccusedForm}
          onViewAccusedForm={onViewAccusedForm}
          data={criminalData}
          columns={criminalHeaders}
          current={props.current}
          pageSize={props.pageSize}
          total={props.total}
          handlePageChange={props.handlePageChange}
          handlePageSizeChange={props.handlePageSizeChange}
          getSerialNumber={props.getSerialNumber}
          id={props.id}
          PSEnvInfo={props.PSEnvInfo}
          PSFilledInfo={props.PSFilledInfo}
          report={props.report}
          usersData={props.usersData}
          sortedInfo={sortedInfo}
          onTableChange={handleTableChange}
          accusedDrawer={props.accusedDrawer}
          pc_crimetypes={props.pc_crimetypes}
          pc_crimetitles={props.pc_crimetitles}
          professionals={props.professionals}
          total_bharthili={props.total_bharthili}
        ></AppTable>
      ) : (
        <AppTable1
          districtId={props?.usersData?.districtId}
          cityid={props.cityid}
          isAccusedFormUpdate={true}
          onEditAccusedForm={onEditAccusedForm}
          onPreventiveViewAccusedForm={onPreventiveViewAccusedForm}
          onViewAccusedForm={onViewAccusedForm}
          data={criminalData}
          columns={criminalHeaders}
          current={props.current}
          pageSize={props.pageSize}
          total={props.total}
          handlePageChange={props.handlePageChange}
          handlePageSizeChange={props.handlePageSizeChange}
          getSerialNumber={props.getSerialNumber}
          id={props.id}
          PSEnvInfo={props.PSEnvInfo}
          PSFilledInfo={props.PSFilledInfo}
          report={props.report}
          pc_crimetypes={props.pc_crimetypes}
          pc_crimetitles={props.pc_crimetitles}
          professionals={props.professionals}
        ></AppTable1>
      )}
    </>
  );
};
